"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// `const ... = require()` instead of `import ... = require()`
// because tsc thinks that `grapheme-splitter` is an ES module:
// `Import assignment cannot be used when targeting ECMAScript modules.`
var GraphemeSplitter = require('grapheme-splitter');
var splitter = new GraphemeSplitter();
/**
 * Convert a space delimited full name to capitalized initials.
 * Returned initials would not exceed 3 or 2 letters, according to provided `limit`.
 * @param limit number If set to 3, then if name has more than 3 parts,
 *  then the 1st, 2nd and last parts would be used. If set to 2, then first and last parts are used.
 */
function nameToInitials(name, limit) {
    if (limit === void 0) { limit = 2; }
    if (!name) {
        return '';
    }
    if (limit < 1 || limit > 3) {
        limit = 2;
    }
    var initials = name.split(' ').map(function (s) { return splitter.splitGraphemes(s)[0]; });
    if (limit === 1 && initials.length > 1) {
        initials = [initials[0]];
    }
    if (limit === 2 && initials.length > 2) {
        initials = [initials[0], initials[initials.length - 1]];
    }
    if (limit === 3 && initials.length > 3) {
        initials = [initials[0], initials[1], initials[initials.length - 1]];
    }
    return initials.join('').toUpperCase();
}
exports.nameToInitials = nameToInitials;
//# sourceMappingURL=util.js.map